import { Button } from "antd";
import React, { useState } from "react";
import { ConfirmTextProps } from "../../../../interfaces/props/ConfirmTextProps";

import classes from "./ConfirmText.module.css";

export const ConfirmText = ({ setModalView }: ConfirmTextProps) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <>
      <div
        className={showAll == false ? classes.modalText : classes.modalTextShow}
      >
        <p>
          Я, субъект персональных данных, в соответствии с Федеральным законом
          от 27 июля 2006 года № 152 «О персональных данных» предоставляю
          согласие на обработку персональных данных, указанных мной в форме на
          сайте в сети «Интернет», владельцем которого является Оператор.
        </p>{" "}
        <p>
          Под персональными данными субъекта персональных данных понимается
          нижеуказанная общая информация: ФИО, адрес электронной почты и номер
          телефона.{" "}
        </p>
        <p>
          Принимая настоящее Соглашение, я выражаю свою заинтересованность и
          полное согласие, что обработка персональных данных может включать в
          себя следующие действия: сбор, систематизацию, накопление, хранение,
          уточнение (обновление, изменение), использование, передачу
          (предоставление, доступ), блокирование, удаление, уничтожение,
          осуществляемых как с использованием средств автоматизации
          (автоматизированная обработка), так и без использования таких средств
          (неавтоматизированная обработка).{" "}
        </p>
        <p>
          Я понимаю и соглашаюсь с тем, что предоставленная информация, является
          полной, точной и достоверной; при предоставлении информации не
          нарушается действующее законодательство Российской Федерации, законные
          права и интересы третьих лиц; вся предоставленная информация заполнена
          мною в отношении себя лично; информация не относится к
          государственной, банковской и/или коммерческой тайне, информация не
          относится к информации о расовой и/или национальной принадлежности,
          политических взглядах, религиозных или философских убеждениях, не
          относится к информации о состоянии здоровья и интимной жизни.{" "}
        </p>{" "}
        <p>
          Я понимаю и соглашаюсь с тем, что Оператор не проверяет достоверность
          персональных данных, предоставляемых мной, и не имеет возможности
          оценивать мою дееспособность и исходит из того, что я предоставляю
          достоверные персональные данные и поддерживаю такие данные в
          актуальном состоянии.
        </p>{" "}
        {/* TODO: Согласие на рассылку сделать отдельно */}
        {/* <p>
          Я понимаю и соглашаюсь с тем, что Оператор имеет право направлять мне
          уведомления о новых продуктах и услугах, специальных предложениях и
          различных событиях, посредством отправки электронных писем, СМС
          сообщений, сообщений в мессенджерах и звонков.
        </p>{" "} */}
        <p>
          Согласие действует по достижении целей обработки или в случае утраты
          необходимости в достижении этих целей, если иное не предусмотрено
          федеральным законом. Согласие может быть отозвано мною в любое время
          на основании моего письменного заявления.
        </p>
      </div>
      <div className={classes.buttons}>
        <Button
          style={{ padding: 0 }}
          type="link"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll === false ? "Показать полностью" : "Скрыть"}
        </Button>
        <Button
          onClick={() => setModalView("selectSign")}
          type="primary"
          style={{ margin: "5px 10px 0 0" }}
        >
          Принять
        </Button>
      </div>
    </>
  );
};
